
import divSpan from '@/components/DivSpan';
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getFieldConfig} from '../sources/source.js';
import dynamicSingleField from '../sources/source-common-module/dynamic-single-field'
import dynamicMultField from '../sources/source-common-module/dynamic-mult-field';
export default {
name: "srm-price-library-view",
directives: {
TransferDom
},
components:{
divSpan,
PopupHeader,
Popup,
dynamicSingleField,
dynamicMultField
},
data(){
return{
priceId:null,
supShortName:'',
srmPriceDto:{},
tabIndex:2,
levelPriceShow:false,
reducePriceShow:false,
offerFieldList:[]
}
},
methods:{
back(){
this.$router.go(-1);
},
getSrmPriceDetail(){
this.$loadingShow()
this.$get(`api/purPrice/${this.priceId}`).then((data) => {
this.$loadingHide()
if(data){
this.srmPriceDto = data;
this.getSrmShortName(this.srmPriceDto.supplierId)
switch(this.srmPriceDto.type){
case'sourcing':
this.srmPriceDto.chType = '寻源导入'
break
case'manual':
this.srmPriceDto.chType = '手工创建'
break
case'priceApproval':
this.srmPriceDto.chType = '价格审批'
break
case'manualImport':
this.srmPriceDto.chType = '手工导入'
break
case'materialAuto':
this.srmPriceDto.chType = '采购物料自动计算'
break
default:
break;
}
}
this.getOfferFields();
}).catch(err=>{this.$loadingHide()})
},
getSrmShortName(payload){
this.$loadingShow()
this.$get(`api/supplier/${payload}`).then((data) => {
this.$loadingHide()
this.supShortName = data.shortName
}).catch(err=>{this.$loadingHide()})
},
changeView(index){
this.tabIndex = index;
},
viewPriceDetail(){
this.$vux.toast.text(`请前往pc端查看价格明细详情`);
},
viewLevelPrice(){
this.levelPriceShow = true;
},
viewReducePrice(){
this.reducePriceShow = true;
},
cancelLevelPrice(){
this.levelPriceShow = false;
},
cancelReducePrice(){
this.reducePriceShow = false;
},
getOfferFields(){
if(this.srmPriceDto.sourcePriceTemplate){
this.offerFieldList = getFieldConfig(this.srmPriceDto.sourcePriceTemplate).offerFieldList;
}
},
viewField(field,dynamicData){
this.$refs.multMatDynamic.initData(field,dynamicData);
}
},
mounted(){
this.priceId = this.$route.params.priceId;
this.getSrmPriceDetail();
}
}



// WEBPACK FOOTER //
// ./src/page/price-library/srm-price-library-view.vue